import { isUndNullEmp } from '../../helpers/main.js';
const currentDateTimeISO = new Date()?.toISOString();

export class RequirementDetail {
    constructor(
        _id = 0,
        _requirementId = 0,
        _analystId = '',
        _registerDate = currentDateTimeISO,
        _commentary = '',
        _register = '',
    ) {
        this.id = _id;
        this.requirementId = _requirementId;
        this.analystId = _analystId;
        this.registerDate = _registerDate;
        this.commentary = _commentary;
        this.register = _register;
    }

    static getClassName = () => {
        return 'RequirementDetail - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 0,
                    RequirementId: 0,
                    AnalystId: 10,
                    RegisterDate: 10,
                    Commentary: 2,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    RequirementId: 450,
                    AnalystId: 450,
                    RegisterDate: 30,
                    Commentary: 1000,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 0,
                    requirementId: 0,
                    analystId: 10,
                    registerDate: 10,
                    commentary: 2,
                    register: 10,
                },
                max: {
                    id: 450,
                    requirementId: 450,
                    analystId: 450,
                    registerDate: 30,
                    commentary: 1000,
                    register: 30,
                },
            };
        }
    }

    // static userIdFullPath = ({userId = '', subMethod = ''} = {}) => {
    //     let response = getResponse({ type: 0 });
    //     const currentMethod = 'RequirementDetail / userIdFullPath';
    //     try {
    //         if(!isUndNullEmp({data: userId, subMethod: currentMethod})?.result){
    //             userId = userId.replace('~/Images/UserIds/RequirementDetail/', `${settings?.backend?.urls?.imageUserIds}${settings?.backend?.urls?.paymentInformations}/`);
    //             response.result = `${settings?.backend?.urls?.api}${userId}`
    //         } else {
    //             response.result = `${settings?.backend?.urls?.api}${settings?.images?.noImage}`;
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}<br/>`;
    //     }
    //     return response;
    // }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: RequirementDetail.getClassName() })?.result) {
            if (upperCase) {
                return new RequirementDetail(
                    obj.Id,
                    obj.RequirementId,
                    obj.AnalystId,
                    obj.RegisterDate,
                    obj.Commentary,
                    obj.Register,
                );
            } else {
                return new RequirementDetail(
                    obj.id,
                    obj.requirementId,
                    obj.analystId,
                    obj.registerDate,
                    obj.commentary,
                    obj.register,
                );
            }
        } else {
            return new RequirementDetail();
        }
    }
}